import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios, { AxiosPromise, CancelToken } from 'axios';

export const useCancelableQuery = <T, E = unknown>(
    queryFn: (cancelToken: CancelToken) => AxiosPromise<T>,
    config?: UseQueryOptions<T, E>,
) => {
    return useQuery({
        queryFn: async ({ signal }) => {
            const cancelToken = axios.CancelToken;
            const source = cancelToken.source();
            const promise = queryFn(source.token);
            signal.addEventListener('abort', () => {
                source.cancel();
            });

            const { data } = await promise;

            return data;
        },
        ...config,
    });
};
